import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-4">
      <p className="text-center">&copy; 2024 jeffreychen</p>
    </footer>
  );
};

export default Footer;
